<template>
  <el-tabs
    type="border-card"
    :stretch="true"
    class="program-edit"
    :value="selectedPane"
  >
    <el-tab-pane
      name="programStyle"
      :label="$t('lcd.Editor.Scenario Style')"
      style="border-right: 0"
    >
      <el-form label-position="top" :model="pageInfo">
        <el-form-item :label="$t('lcd.Editor.Background Color')">
          <el-color-picker
            v-model="pageInfo.bgColor"
            show-alpha
            :predefine="predefineColors"
            size="mini"
            v-if="!pageColor"
          />
          <!-- 'rgba(0,0,0,1)',        // 黑
  'rgba(255,255,255,1)',  // 白
  'rgba(255,0,0,1)',      // 红
  'rgba(255,255,0,1)',    // 黄
  'rgba(0,0,255,1)',      // 蓝
  'rgba(0,255,0,1)',      // 绿
  'rgba(255,125,0,1)',    // 橙 -->
          <div class="EditorEslColorList" v-if="pageColor">
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBgColor(index)"
                class="colorLi"
                :style="{background: c.color}"
              ></span>
            </i>
          </div>
        </el-form-item>
        <el-form-item
          v-if="!pageColor"
          :label="$t('lcd.Editor.Background Img')"
        >
          <el-input
            size="mini"
            :placeholder="$t('lcd.Editor.Please Select Background Img')"
            v-model="pageInfo.bgImg"
            class="input-with-select"
            disabled
            style="border-right: 0"
          >
            <el-button-group class="appendButtonGroup" slot="append">
              <el-button
                type="text"
                @click="clearBgImg"
                icon="el-icon-close"
                style="padding-right: 8px"
              ></el-button>
              <el-button
                type="text"
                @click="handleSelectBgImg"
                icon="el-icon-picture-outline"
                style="border-left-color: rgb(228, 231, 237); padding-left: 8px"
              ></el-button>
            </el-button-group>
          </el-input>
        </el-form-item>
        <!-- {{pageInfo}} -->
        <!-- <el-form-item label="刷新时间">
          <el-input-number
            v-model="pageInfo.interval"
            label="秒"
            :min="0"
            :max="Number.MAX_SAFE_INTEGER"
            size="mini"
          />
        </el-form-item> -->
        <!-- <el-form-item label-width="10px">
          <div class="custom-script">{{ $t("lcd.Editor.Custom Script") }}</div>
          <el-input v-model="pageInfo.customScript" rows="8" type="textarea" />
        </el-form-item> -->
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { predefineColors, colorList } from "../../../utils/constant";
import store from "../../../store/index.js";
import eventbus from "../../../utils/eventbus";

export default {
  name: "TumengProgramEdit",
  data() {
    return {
      predefineColors,
      colorList,
      selectedPane: "programStyle",
      state: store.state,
      customScript: undefined,
    };
  },
  computed: {
    // {{state.programInfo.color}}
    // {{state.programInfo}}
    pageColor() {
      return this.state.programInfo.color ? this.state.programInfo.color : "";
    },
    pageInfo() {
      return this.state.programInfo.pages[this.state.currentPageIdx];
    },
  },
  methods: {
    handleSelectBgImg() {
      eventbus.$emit("img-list-change", 0);
      store.SET_SELECT_IMG_OPERATION("SET_PROGRAM_BG_IMG");
      store.updateSelectImgDialogVisible(true);
    },
    clearBgImg() {
      store.setPageBGImg("", null);
    },
    selectedDataset() {
      store.updateSelectDatasetDialogVisible(true);
    },
    changeBgColor(index) {
      // console.log('changecolor')
      // console.log(this.colorList)
      // console.log(this.colorList[index])
      this.pageInfo.bgColor = this.colorList[index].color;
    },
  },
};
</script>

<style lang="scss" scoped>
.program-edit {
  margin: 8px;

  ::v-deep .el-form-item {
    margin: 0 0 8px;

    .el-form-item__label {
      padding: 0;
    }

    .image,
    .close {
      font-size: 18px;
      color: #606266;
      cursor: pointer;
    }
  }
  ::v-deep .el-form-item__label {
    line-height: 28px;
  }

  .custom-script {
    font-size: 14px;
    color: #606266;
    line-height: 28px;
    // font-weight: bold;
  }
  ::v-deep .appendButtonGroup {
    padding: 0;
    width: 48px;
    height: 26px;
    line-height: 26px;
    .el-button {
      margin: 0;
      height: 26px;
      line-height: 26px;
      padding: 0;
    }
  }
  ::v-deep .el-input-group__append {
    padding: 0 8px;
  }
  ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-right: 0 !important;
    margin-right: -1px !important;
  }
}
</style>

<style lang="scss" >
.EditorEslColorList {
  height: 24px;
  .colorLi {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 10px;
    border: 1px solid #606266;
    border-radius: 2px;
    cursor: pointer !important;
    background: rgba(0, 0, 0, 1);
  }
}
</style>
